import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardActions from '@material-ui/core/CardActions';
import CardStatus from '../CardStatus';
import { connect } from 'react-redux';
import darkGradient from '../../assets/darkGradient.svg'
import mail from '../../assets/closeEnvelope.svg';
import LinearProgress from '@material-ui/core/LinearProgress';
import {withRouter} from 'react-router-dom'
import iconModule from '../../assets/icon_module_b.png';

import { commonStyles, COLORS } from '../../styles/styles';
import {
  getPrograms,
  selectedModule,
  getUserPrograms,
  selectedModuleId,
  selectedProgramId
} from '../../redux/selectors';
import placeHolder from '../../assets/modPlaceHolder.png'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import {
  MDBCard,
  MDBCardTitle,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBProgress
} from "mdbreact";
import { getSelectedModule } from '../../utils';
import { setFilter } from '../../redux/reducers/userProgramsFull';
import { STORAGE_LINK } from '../../constants';

const getCompleted =(programs, mod)=>{
  
  for (let i = 0; i < programs.length; i++) {
    const p = programs[i];
    
    for (let j = 0; j < p.modules.length; j++) {
      const m = p.modules[j];
      
      if(m.moduleId===mod.moduleId){
        var totalCompleted= 0;
        for (let k = 0; k < m.content.length; k++) {
          const c = m.content[k];
          
          if(c.status=='completed'){
            totalCompleted++;
          }
          
        }
      }
      
    }
    
  }
  return totalCompleted
}
const getTotal =(mod)=>{
 
  return mod.content ? mod.content.length : null
}

const ModulesCardReturn = ({ classes, ...props }) => {
  const {
    isActive: isActiveProp,
    isSelected: isSelectedProp,
    status,
    name,
    description,
    startDate,
    dueDate,
    messages,
    programs,
    moduleId,
    background,
    getModule,
    handleBack,
    handleImageLoaded,
    imageLoadedNow
  } = props;
  
  var totalComponents = 0;
  var totalCompleted= 0;
  var percentage = 0
  
  try {
    for (let i = 0; i < programs.length; i++) {
      const p = programs[i];
     
      for (let j = 0; j < p.modules.length; j++) {
        const m = p.modules[j];
        
        if(m.description===description && m.name===name){
          for (let k = 0; k < m.content.length; k++) {
            const c = m.content[k];
           
            totalComponents++;
            if(c.status=='completed'){
              totalCompleted++;
            }
            
          }
        }
        
      }
      
    }
  } catch (error) {
    
  }
  return (
    <div>

      { getModule  && <MDBCard
    className="card-image rounded-0 z-depth-3 d-none d-md-block"
    style={{
      padding:8,
      margin: '0 0px 5px',
    }}
  >
      <MDBBtn
          floating
          left
          tag='a'
          size='sm'
          className='ml-auto ml-4 '
          action
          style={{position: 'absolute', left: -20, top:20, zIndex:800}} 
          onClick={()=>handleBack()}
        >
        <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
      </MDBBtn>
      <div>
        <div style={{position: 'relative'}}>
          <div class="moduleImg">
            <img src={STORAGE_LINK+getModule.thumbLoc} className="z-depth-0 "
                          alt=""  onLoad={handleImageLoaded}  />
          </div>
          <div style={{position:'absolute', right:10, top:10}}>
            <CardStatus className="dark-grey-text" status={getModule.status}/>
          </div>
          
          <div className="moduleCopy">
            {/* <div className="moduleIcon">
              <img src={iconModule} />
            </div> */}
            <h6>
              {getModule.name}
            </h6>
            <div className="copy">
              {getModule.description}
            </div>
          </div>

          

          
          {/* <img src={placeHolder} className="z-depth-0" style={{position:'sticky',top:0,left:0,padding: 0,width: '100%'}} alt=""/>
          <img src={STORAGE_LINK+getModule.thumbLoc} className="z-depth-0"
                            style={{position:'absolute',top:0,left:0,padding: 0, 
                          width: '100%'}} alt="" onLoad={handleImageLoaded} />
          <div style={{padding: 0, height: '100%', width: '100%', position:'absolute', bottom:0, left:0}} className='background-gradient-main'></div>
            <div className="text-white align-items-center py-5 px-4" style={{position:'absolute', height: '100%', top: 0, width: '100%'}}>
            <div style={{position:'absolute', right:10, top:10}}>
              <CardStatus className="dark-grey-text" status={getModule.status}/>
            </div>
            <div style={{width:'100%'}}>
              <h6 tag="h5" className="pt-4">
                <strong>{getModule.name}</strong>
              </h6>
              <p>
                {getModule.description}
              </p>
              <div className={classes.completionDetails}>
                <span className={classes.progressFig}>{getModule.completed}/{getModule.components}</span> Completed
              </div>
            </div>
          </div> */}
        </div>
      </div> 

      <div className="completionDetails">
        <span className={classes.progressFig}>{getModule.completed}/{getModule.components}</span> Completed
      </div>
      <img src={placeHolder} className="z-depth-0 compLoader" style={{position:'absolute',top:0,left:0,padding: 0,width: '100%'}} alt=""/>
      {/* <div className="progressHolder"> <MDBProgress className="mb-0" material value={Math.round((getModule.completed/getModule.components)*100)} color="warning" /></div> */}
      <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>{imageLoadedNow && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
            <div style={{position:'absolute', top:"40%", width:'100%'}}>
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
          color={COLORS.cornerstoneRed}
           loading={true}
         />
         </div>
          </div>}</ReactCSSTransitionGroup>
  </MDBCard> }
    </div>
  );
 
};

const styles = () => ({
  ...commonStyles,
  linearColorPrimary: {
    backgroundColor: '#000000',
  },
  linearBarColorPrimary: {
    backgroundColor: '#8a272a',
  },
  card: {
    color: '#cbcaca',
    width: 200,
    height: 221,
    borderRadius: 0,
    backgroundSize: 'cover',
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
    paddingBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    border: '0.1px solid #efefef',
    position: 'relative',
    overflow: 'visible',
    backgroundColor: '#fff',
    opacity: 1,
    cursor: 'default',
    justifyContent: 'space-between',
    transition: '.2s height ease',
  },
  cardContent: {
    padding: 0,
  },
  iconsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    margin: 0,
  },
  isActive: {
    opacity: 1,
    cursor: 'pointer',
  },
  moduleDescription: {
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    marginTop: 10,
    marginBottom: 10,
    maxHeight: 30,
    overflow: 'hidden',
  },
  assessmentDescription: {
    fontSize: 10,
    lineHeight: '14px',
    fontWeight: 400,
    maxHeight: 30,
    overflow: 'hidden',
    color:COLORS.white
  },
  completionDetails:{
    fontFamily: 'GothamHTF-Book',
    fontSize: '1rem',
  },
  progressFig:{
    fontFamily: 'Gotham-Black',
  },
  progressHolder:{
    position: 'absolute', 
    bottom: 0, 
    zIndex: 3, 
    left: 0, 
    width: '100%', 
    padding: '14px 14px', 
    backgroundColor: '#F7F7F7',
    borderTop: '1px solid #DDDDDD'
  }
});
const mapStateToProps = state => ({
  programs: getUserPrograms(state),
  getModule: selectedModule(state),
  selectedProgramId: selectedProgramId(state)
});

const mapDispatchToProps = dispatch => ({
  setFilter: contentId => dispatch(setFilter(contentId)),
});

export default compose( 
withRouter,
connect(
  mapStateToProps,
  mapDispatchToProps
),
withState('imageLoadedNow', 'toggleImageLoaded', true),
withHandlers({
  handleBack: props => () => {
    props.setFilter(['All'])
    props.history.push(`/modules/${props.selectedProgramId}`);
   },
   handleImageLoaded: props => () => {
    props.toggleImageLoaded(false)
  }
}),
withStyles(styles))(ModulesCardReturn);

ModulesCardReturn.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isActive: PropTypes.bool,
  isSelected: PropTypes.bool,
  status: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  dueDate: PropTypes.string,
  messages: PropTypes.string,
};
